var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"tippy",rawName:"v-tippy",value:({ placement: 'bottom' }),expression:"{ placement: 'bottom' }"}],staticClass:"iconbutton toggle-button",attrs:{"type":"button","content":"Toon data","aria-label":"Toon data"},on:{"click":_vm.showDataPanel}},[_c('FormIcon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }